import React, { useContext, useState } from "react";
import { Tooltip, Box } from "@mui/material";
import { ThemeContext } from "../../theme/ThemeContext";
import { useTranslation } from "react-i18next";

const ViewIcon = () => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  return (
    <>
      <Tooltip title={t("VIEW")}>
        <Box className={darkMode ? 'iconButton_dark' : 'iconButton'}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          {isHovered ?
            (
              <svg xmlns="http://www.w3.org/2000/svg" width="19.998" height="15.18" viewBox="0 0 19.998 15.18">
                <path id="Subtraction_125" data-name="Subtraction 125" d="M14934-19635.82a10.335,10.335,0,0,1-6.233-2.066,10.388,10.388,0,0,1-3.724-5.242.941.941,0,0,1-.044-.281,1,1,0,0,1,.044-.285,10.4,10.4,0,0,1,3.724-5.238A10.335,10.335,0,0,1,14934-19651a10.334,10.334,0,0,1,6.229,2.066,10.4,10.4,0,0,1,3.724,5.238,1,1,0,0,1,.044.285.941.941,0,0,1-.044.281,10.388,10.388,0,0,1-3.724,5.242A10.334,10.334,0,0,1,14934-19635.82Zm0-11.383a3.8,3.8,0,0,0-3.8,3.793,3.8,3.8,0,0,0,3.8,3.793,3.8,3.8,0,0,0,3.793-3.793A3.8,3.8,0,0,0,14934-19647.2Zm0,5.691a1.9,1.9,0,0,1-1.9-1.9,1.9,1.9,0,0,1,1.9-1.9,1.9,1.9,0,0,1,1.895,1.9A1.9,1.9,0,0,1,14934-19641.512Z" transform="translate(-14924.001 19651)" fill={darkMode ? '#fff' : '#474a4e'} />
              </svg>
            ) :
            (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15.177" viewBox="0 0 20 15.177">
                <path id="Path_30514" data-name="Path 30514" d="M3.768,13.112A10.393,10.393,0,0,1,.044,7.873a.934.934,0,0,1,0-.568,10.435,10.435,0,0,1,16.188-5.24,10.367,10.367,0,0,1,3.724,5.24.947.947,0,0,1,0,.568,10.375,10.375,0,0,1-3.724,5.239,10.436,10.436,0,0,1-12.464,0ZM10,13.28a8.5,8.5,0,0,0,8.051-5.691,8.541,8.541,0,0,0-16.1,0A8.5,8.5,0,0,0,10,13.28ZM6.207,7.589A3.794,3.794,0,1,1,10,11.383,3.8,3.8,0,0,1,6.207,7.589ZM10,9.487a1.9,1.9,0,1,0-1.9-1.9A1.9,1.9,0,0,0,10,9.487Z" fill={darkMode ? '#fff' : '#474a4e'} opacity="0.8" />
              </svg>
            )
          }
        </Box>
      </Tooltip>
    </>
  );
};

export default ViewIcon;
